import env from '../../server.config'

/** 
 * @description route level code-splitting
 * this generates a separate chunk ({routename}.[hash].js) for this route
 *  which is lazy-loaded when the route is visited
 * @example
 *  {
 *    path: '/routeexample',
 *    component: () => import('../views/RouteExample.vue'),
 *    meta: {
 *      requiresAuth: true,
 *    }
 *  }
 * @summary tldr: import with arrow function is a better use of resources
 * @exports Array array of objects, which define route names and their respective component
 */
export default [
 {
   path: '/login',
   component: () => import('../views/login/Login'),
  },
  {
    path: '/',
    component: () => import('../views/login/Login'),
  },
  {
    path: '/login/:alert',
    component: () => import('../views/login/Login'),
    props: true
  },
  {
    path: '/home',
    component: () => import('../views/Home'),
    meta: {
      requiresAuth: true,
    },
 },
 {
  path: '/integrator',
  component: () => import('../views/Integrator'),
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/gateway',
  component: () => import('../views/Gateway'),
  props: {systemId: ''},
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/gateway/:systemId',
  component: () => import('../views/Gateway'),
  props: true,
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/systems',
  component: () => import('../views/Systems'),
  props: {searchSerNum: ''},
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/systems/:searchSerNum',
  component: () => import('../views/Systems'),
  props: true,
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/SysDetails/:systemSerNum',
  component: () => import('../views/SysDetails'),
  props: true,
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/licenses',
  component: () => import('../views/Licenses'),
  props: {searchSerNum: ''},
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/licenses/:searchSerNum',
  component: () => import('../views/Licenses'),
  props: true,
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/licenseHistory/:encodedWgip',
  component: () => import('../views/LicenseHistory'),
  props: true,
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/deploy',
  component: () => import('../views/DeployUi'),
  props: {showDeploymentOptions: true},
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/cardImport',
  component: () => import('../views/CardImport'),
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/health/deploy',
  component: () => import('../views/DeployUi'),
  props: {showDeploymentOptions: false},
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/health/deploy/:systemSerNum',
  component: () => import('../views/DeployUi'),
  props: true, // this leaves DeployUi::showDeploymentOptions false,
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/health/cameras',
  component: () => import('../views/Cameras'),
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/health/doors',
  component: () => import('../views/Doors'),
  meta: {
    requiresAuth: true,
  },
},
{
  path: '/portal',
  beforeEnter() {
    window.location.href = env.apiBaseUrl + '/#/home';
    },   
  meta: {
    requiresAuth: true,
  },
},
{
  path: '*',
  component: () => import('../views/Home'),
  meta: {
    requiresAuth: true,
  },
},
]
